export const routerPathNames = {
  Default: "",
  Map: "/",
  Reports: "/reports",
};
